import { Injectable } from '@angular/core';
import { SingletonCheckHelper } from '../helpers/singleton-check.helper';
import { LocalStorageService } from 'ngx-webstorage';

@Injectable({
    providedIn: 'root'
  })
export class TcmImagesSystemService {

    constructor(
        private localStorageService: LocalStorageService
    ) {
        SingletonCheckHelper.ensureSingleton(this);
        this.images.forEach(image => {
            this.setImages(image);
          });

    }
    public logoDefault = '/assets/images/presentation/logo.png';
    public loginPrimaryBannerDefault = '/assets/images/presentation/LoginPrimaryBanner.jpg';
    public loginSecondaryBannerDefault = '/assets/images/presentation/LoginSecondaryBanner.jpg';
    public loginThirdBannerDefault = '/assets/images/presentation/LoginThirdBanner.jpg';
    public logoSystem = '/api/SystemPreferences/Logo';
    public loginPrimaryBannerSystem = '/api/SystemPreferences/LoginPrimaryBanner';
    public loginSecondaryBannerSystem = '/api/SystemPreferences/LoginSecondaryBanner';
    public loginThirdBannerSystem = '/api/SystemPreferences/LoginThirdBanner';
    public logo = '';
    public loginPrimaryBanner = '';
    public loginSecondaryBanner = '';
    public loginThirdBanner = '';
    public images = [
        'logo',
        'loginPrimaryBanner',
        'loginSecondaryBanner',
        'loginThirdBanner'
        ];

    setImage(imageKey: string, imagUrl: string) {
        this.localStorageService.store(imageKey, imagUrl);
        this[imageKey] = this[imageKey+'System']
    }

    getImage(imageKey: string) {
       return this.localStorageService.retrieve(imageKey);
    }

    deleteImage(imageKey: string) {
        this.localStorageService.clear(imageKey)
        this[imageKey] = this[imageKey+'Default']
    }

    setImages(image) {
        var localStorage = this.getImage(image);
        if(!localStorage) {
          this[image] = this[image+'Default'];
        } else {
          this[image] = this[image+'System'];
        }
      }
}
